import type { JobSummary } from '@/api/types';

/** Stable fingerprint of job counts that affect cleanup eligibility previews. */
export function jobsCleanupRefreshSignal(summary: JobSummary | null): string | null {
  if (!summary?.jobs) return null;
  const jobs = summary.jobs;
  return `${jobs.completed ?? 0}:${jobs.cancelled ?? 0}:${jobs.failed ?? 0}:${jobs.partial_failed ?? 0}`;
}
